// extracted by mini-css-extract-plugin
export var askAiIcon = "_rg-9";
export var container = "_rg-0";
export var groupSeparator = "_rg-a";
export var highlight = "_rg-4";
export var resultIcon = "_rg-5";
export var resultItem = "_rg-7";
export var resultSubtitle = "_rg-3";
export var resultTitle = "_rg-2";
export var resultsList = "_rg-1";
export var searchGroup = "_rg-6";
export var selected = "_rg-8";